import React, {Component} from 'react'
import DestinationItem from '../DestinationItem'
import './index.css'

class DestinationSearch extends Component {
  state = {searchInput: ''}

  onSearchInput = event => {
    this.setState({searchInput: event.target.value})
  }

  getFilteredItems = () => {
    const {destinationsList} = this.props
    const {searchInput} = this.state
    return destinationsList.filter(destination =>
      destination.name.toLowerCase().includes(searchInput.toLowerCase()),
    )
  }

  render() {
    const getFilteredDestination = this.getFilteredItems()
    return (
      <div className="main-container">
        <h1>Destination Search</h1>
        <div className="inputcontainer">
          <input
            type="search"
            placeholder="Enter your destination"
            className="searchinput"
            onChange={this.onSearchInput}
          />
          <img
            src="https://assets.ccbp.in/frontend/react-js/destinations-search-icon-img.png"
            className="imageicon"
            alt="search icon"
          />
        </div>
        <ul className="itemslist">
          {getFilteredDestination.map(destination => (
            <DestinationItem
              key={destination.id}
              destinationDetails={destination}
            />
          ))}
        </ul>
      </div>
    )
  }
}
export default DestinationSearch
